export class SessionCacheManager
{

    private keys = {
        SearchResults:'SearchResults',
        SearchString:'SearchString'
    };

    constructor()
    {
    }

    // Search Results
    get SearchResults(): any
    {
        return sessionStorage[this.keys.SearchResults] ? (JSON.parse(sessionStorage[this.keys.SearchResults])) : null;
    }

    set SearchResults(response: any)
    {
        sessionStorage[this.keys.SearchResults] = JSON.stringify(response);
    }

    removeSearchResults(){
        sessionStorage.removeItem(this.keys.SearchString);
    }

    // Search String
    get SearchString(): string
    {
        return sessionStorage[this.keys.SearchString] ? sessionStorage[this.keys.SearchString] : null;
    }

    set SearchString(response: string)
    {
        sessionStorage[this.keys.SearchString] = response;
    }

    removeSearchString(){
        sessionStorage.removeItem(this.keys.SearchString);
    }
}
